import { user } from '../account/fields.js'

export const auth = `user(${user})`
export default { auth }
